/** Local static assets under /public/images (DigiRobot brand) */

export const IMAGES = {
  /** Cutout mascotte seule (PNG transparent) */
  hero: "/images/robot-mascot.png",
  mascot: "/images/robot-mascot.png",
  robotMascot: "/images/robot-mascot.png",
  /** Photo réaliste atelier humains — fond full-bleed Home */
  heroAtelier: "/images/hero-atelier.png",
  /** Scène mascotte 3D (sans enfants CGI) — accents / CTA, pas hero Home seul */
  mascotteScene: "/images/mascotte-scene.png",
  heroHome: "/images/hero-atelier.png",
  heroBanner: "/images/hero.png",
  logo: "/images/logo-head.png",
  logoSvg: "/images/logo.svg",
  logoLong: "/images/logo-long.png",
  logoLongWhite: "/images/logo-long-white.png",
  logoHeadWhite: "/images/logo-head-white.png",
  favicon: "/images/favicon.png",
  /** Legacy DigiRobot hero textures (BACKUP/uploads) */
  legacy: {
    dots: "/images/legacy/element01@4x.png",
    bannerBg: "/images/legacy/home-banner-bg.png",
    bannerStyle: "/images/legacy/home-banner-style.png",
    robotSeul: "/images/legacy/robot-seul-digirobot@4x.png",
  },
  about: {
    workshop: "/images/about/workshop.jpg",
  },
  workshops: {
    decouverte: "/images/workshops/decouverte.jpg",
    defi: "/images/workshops/defi.jpg",
    particulier: "/images/workshops/particulier.jpg",
    /** Gen 07 duel-echec — hero page Ateliers */
    hero: "/images/workshops/hero.png",
    videoPreview: "/images/workshops/video-preview.jpg",
  },
  cursus: {
    debutant: "/images/cursus/debutant.jpg",
    intermediaire: "/images/cursus/intermediaire.jpg",
    avance: "/images/cursus/avance.jpg",
    /** Gen 04 cursus-focus — hero page Cursus */
    hero: "/images/cursus/hero.png",
  },
  stages: {
    arduino: "/images/stages/arduino.jpg",
    makeblock: "/images/stages/makeblock.jpg",
    drone: "/images/stages/drone.jpg",
    imprimante3d: "/images/stages/imprimante-3d.jpg",
    lego: "/images/stages/lego.jpg",
    funLearn: "/images/stages/fun-learn.png",
    /** Gen 03 stage-groupe — hero page Stages */
    hero: "/images/stages/hero.png",
    default: "/images/stages/fun-learn.png",
  },
  centers: {
    "nice-gambetta": "/images/centers/nice-gambetta.jpg",
    "nice-jean-medecin": "/images/legacy/nice-jean-medecin-digirobot.jpg",
    pegomas: "/images/centers/pegomas.jpg",
    "cagnes-sur-mer": "/images/centers/cagnes-sur-mer.jpg",
    cannes: "/images/centers/cannes.jpg",
    monaco: "/images/centers/monaco.jpg",
  },
  partners: {
    algora: "/images/partners/algora.png",
    eibNice: "/images/partners/eib-nice.jpg",
    eibCagnes: "/images/partners/eib-cagnes.jpg",
    eibPegomas: "/images/partners/eib-pegomas.jpg",
    eibCil: "/images/partners/eib-cil.jpg",
    cjps: "/images/partners/cjps.jpg",
  },
  offers: {
    rb1: "/images/offers/rb1-digirobot-offres.jpg",
    rb2: "/images/offers/rb2-digirobot-offres.jpg",
    rb3: "/images/offers/rb3-digirobot-offres.jpg",
    rb4: "/images/offers/rb4-digirobot-offres.jpg",
    rb5: "/images/offers/rb5-digirobot-offres.jpg",
  },
  gallery: {
    robotSeul: "/images/gallery/robot-seul.png",
    robotSpider: "/images/gallery/robot-spider.png",
    robotFootballBg: "/images/gallery/robot-football-bg.png",
    bulldozer: "/images/gallery/bulldozer.png",
    product: "/images/gallery/digirobot-product.jpg",
    centerAntibes: "/images/gallery/center-antibes.jpg",
    centerNiceJeanMedecin: "/images/gallery/center-nice-jean-medecin.jpg",
  },
  robots: {
    attrapeBlocs: "/images/robots/attrape-blocs.jpg",
    attraperObjets: "/images/robots/attraper-des-objets.jpg",
    avancerReculer: "/images/robots/avancer-et-reculer.jpg",
    bulldozer: "/images/robots/bulldozer.jpg",
    cannePeche: "/images/robots/canne-a-peche.jpg",
    catapulte: "/images/robots/catapulte.jpg",
    clavier: "/images/robots/clavier.jpg",
    coffre: "/images/robots/coffre.jpg",
    conduireSansMains: "/images/robots/conduire-sans-les-main.jpg",
    creatureRobotique: "/images/robots/creature-robotique.jpg",
    creatureRobotique2: "/images/robots/creature-robotique2.jpg",
    crocobot: "/images/robots/crocobot.jpg",
    deplacerObjets: "/images/robots/deplacer-des-objets.jpg",
    detecteurSeisme: "/images/robots/detecteur-de-tremblement-de-terre.jpg",
    feuxSignalisation: "/images/robots/feux-de-signalisation.jpg",
    grenouille: "/images/robots/grenouille.jpg",
    jeuBowling: "/images/robots/jeu-de-bowling.jpg",
    jeuxHockey: "/images/robots/jeux-de-hockey.jpg",
    lanceElastique: "/images/robots/lance-elastique.jpg",
    lanceurAvion69: "/images/robots/lanceur-d-avion-6-9.jpg",
    lanceurAvionsPapier: "/images/robots/lanceur-d-avions-en-papier.jpg",
    manege: "/images/robots/manege.jpg",
    millePattes: "/images/robots/mille-pattes.jpg",
    monoRail: "/images/robots/mono-rail.jpg",
    monterSommet: "/images/robots/monter-au-sommet.jpg",
    robotArtiste: "/images/robots/robot-artiste.jpg",
    robotBatterie: "/images/robots/robot-batterie.jpg",
    robotChenille: "/images/robots/robot-chenille.jpg",
    robotChien2: "/images/robots/robot-chien-2.jpg",
    robotCombat: "/images/robots/robot-de-combat.jpg",
    robotCombat2: "/images/robots/robot-de-combat2.jpg",
    robotDanceur: "/images/robots/robot-danceur.jpg",
    robotElevateur: "/images/robots/robot-elevateur.jpg",
    robotFootballeur: "/images/robots/robot-footballeur.jpg",
    robotGolf: "/images/robots/robot-golf.jpg",
    robotMoto: "/images/robots/robot-moto.jpg",
    robotSumo: "/images/robots/robot-sumo.jpg",
    robotSumo2: "/images/robots/robot-sumo2.jpg",
    robotArpenteur: "/images/robots/robot-arpenteur.jpg",
    robotArpenteur2: "/images/robots/robot-arpenteur2.jpg",
    scanner: "/images/robots/scanner.jpg",
    sonLumiere: "/images/robots/son-et-lumiere.jpg",
    tireCible: "/images/robots/tire-sur-cible.jpg",
    toupie: "/images/robots/toupie.jpg",
    tournerGaucheDroite: "/images/robots/tourner-a-gauche-et-a-droite.jpg",
    voiture69: "/images/robots/voiture-6-9.jpg",
    voitureTelecommandee: "/images/robots/voiture-telecommander.jpg",
    voitureToutTerrain: "/images/robots/voiture-tout-terrain.jpg",
    voitureToutTerrain2: "/images/robots/voiture-tout-terrain2.jpg",
  },
};

export const WORKSHOP_IMAGES = {
  decouverte: IMAGES.workshops.decouverte,
  defi: IMAGES.workshops.defi,
  particulier: IMAGES.workshops.particulier,
};

export const STAGE_IMAGES = {
  arduino: IMAGES.stages.arduino,
  makeblock: IMAGES.stages.makeblock,
  drone: IMAGES.stages.drone,
  lego: IMAGES.stages.lego,
  "imprimante 3d": IMAGES.stages.imprimante3d,
  "imprimante-3d": IMAGES.stages.imprimante3d,
  "fun-learn": IMAGES.stages.funLearn,
  funlearn: IMAGES.stages.funLearn,
  default: IMAGES.stages.default,
};

/** Image stage : image_url Mongo en priorité, sinon thème, sinon fallback (jamais robot-mascot). */
export function resolveStageImage(stage) {
  const custom = typeof stage?.image_url === "string" ? stage.image_url.trim() : "";
  if (custom) return custom;
  const theme = String(stage?.theme || "")
    .trim()
    .toLowerCase()
    .replace(/_/g, "-");
  if (theme && STAGE_IMAGES[theme]) return STAGE_IMAGES[theme];
  const spaced = theme.replace(/-/g, " ");
  if (spaced && STAGE_IMAGES[spaced]) return STAGE_IMAGES[spaced];
  return STAGE_IMAGES.default;
}

export const CENTER_IMAGES = IMAGES.centers;

/** Workshop ambiance photos (classroom / hands-on) */
export const WORKSHOP_GALLERY = Array.from({ length: 16 }, (_, i) =>
  `/images/gallery/workshops/digirobot-school${i + 1}.jpg`
);
